import { Component, OnInit, Input, OnDestroy, Inject } from "@angular/core";
import { NestedTreeControl } from "@angular/cdk/tree";
import { MatTreeNestedDataSource } from "@angular/material/tree";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { TableField } from "src/app/models/table/table.field.model";
import { TableEnvironment } from "src/app/models/table/table.env.model";
import { GridDataType } from "src/app/models/table/table.gtid.model";

interface FoodNode {
  nombre_es: string;
  nombre_en: string;
  value: string;
  tipo: string;
  children?: FoodNode[];
}

/*const TREE_DATA: FoodNode[] = [
  {
    name: 'Fruit',
    children: [
      {name: 'Apple'},
      {name: 'Banana'},
      {name: 'Fruit loops'},
    ]
  }, {
    name: 'Vegetables',
    children: [
      {
        name: 'Green',
        children: [
          {name: 'Broccoli',
          children: [
            {name: 'Broccoli1'},
            {name: 'Broccoli2'},
            {name: 'Broccoli3'}
          ]
        },
          {name: 'Brussels sprouts'},
        ]
      }, {
        name: 'Orange',
        children: [
          {name: 'Pumpkins'},
          {name: 'Carrots'},
        ]
      },
    ]
  },
];*/

@Component({
  selector: "app-column-tree",
  templateUrl: "./column-tree.component.html",
  styleUrls: ["./column-tree.component.scss"],
})
export class ColumnTreeComponent implements OnInit, OnDestroy {
  public tableFieldCollection: TableField[] = [];
  treeControl = new NestedTreeControl<FoodNode>((node) => node.children);
  dataSource = new MatTreeNestedDataSource<FoodNode>();

  constructor(
    public dialogRef: MatDialogRef<ColumnTreeComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any[]
  ) {}

  hasChild = (_: number, node: FoodNode) =>
    !!node.children && node.children.length > 0;

  ngOnInit() {
    this.initNode(this.data);
  }

  initNode(data: any[]) {
    if (data) {
      let datafield: any;
      let uuidField: string;

      let dataNode: FoodNode;
      let tree_data: FoodNode[] = [];

      //Identificador único de columna anidada
      uuidField = data[1]["uuid"];
      //Array de definición de columnas
      this.tableFieldCollection = data[1]["columns"].where(
        (t) => t.uuid == uuidField
      );
      //Array de datos

      datafield = data[0];
      for (const columnDef of this.tableFieldCollection) {
        //datafield = datafield[columnDef.uuid];

        if (columnDef.tipo == TableEnvironment.OBJECT_TYPE) {
          dataNode = <FoodNode>{
            nombre_en: columnDef.nombre_en,
            nombre_es: columnDef.nombre_es,
            tipo: columnDef.tipo,
            children: this.getChildren(datafield, columnDef.childField),
          };
        } else {
          dataNode = <FoodNode>{
            nombre_en: columnDef.nombre_en,
            nombre_es: columnDef.nombre_es,
            tipo: columnDef.tipo,
            value: this.getValueToEdit(datafield, columnDef.uuid),
          };
        }

        tree_data.add(dataNode);
      }

      this.dataSource.data = tree_data;
    }
  }

  getChildren(dataRow: GridDataType, childNode: TableField[]): FoodNode[] {
    let dataNode: FoodNode;
    let tree_data: FoodNode[] = [];

    for (const columnDef of childNode) {
      if (columnDef.tipo == TableEnvironment.OBJECT_TYPE) {
        dataNode = <FoodNode>{
          nombre_en: columnDef.nombre_en,
          nombre_es: columnDef.nombre_es,
          tipo: columnDef.tipo,
          children: this.getChildren(dataRow, columnDef.childField),
        };
      } else {
        dataNode = <FoodNode>{
          nombre_en: columnDef.nombre_en,
          nombre_es: columnDef.nombre_es,
          tipo: columnDef.tipo,
          value: this.getValueToEdit(dataRow, columnDef.uuid),
        };
      }

      tree_data.add(dataNode);
    }

    return tree_data;
  }

  getValueToEdit(valuesForm: GridDataType, uuid: string): string {
    let tempFieldData: GridDataType[] = [];
    let result: string = null;

    for (let columnKey of Object.keys(valuesForm)) {
      if (uuid == columnKey) {
        if (valuesForm[uuid].type != TableEnvironment.OBJECT_TYPE) {
          return valuesForm[uuid].value;
        }
      }

      if (valuesForm[columnKey].childRow) {
        tempFieldData = tempFieldData.concat(valuesForm[columnKey].childRow);
      }
    }
    for (let index = 0; index < tempFieldData.length; index++) {
      let dataValue: string;
      dataValue = this.getValueToEdit(tempFieldData[index], uuid);

      if (dataValue != null) return dataValue;
    }

    return null;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  ngOnDestroy() {}
}
